import type { FragmentType } from "../../../../../../__generated__/gql";
import { graphql, useFragment } from "../../../../../../__generated__/gql";
import type { AreaGuideSpotCategory } from "../../../../../../__generated__/gql/graphql";

import { SpotCard } from "./spot-card";
import { SpotsEmptyState } from "./spots-empty-state";

export const SpotsListFragment = graphql(`
  fragment SpotsList_Area on Area {
    content {
      guideSpots {
        id
        # categories はカテゴリタブの絞り込み判定で使う (フィルタ後に SpotCard へ渡す)。
        categories
        ...SpotCard_AreaGuideSpot
      }
    }
  }
`);

export function SpotsList({
  area: areaData,
  activeCategory,
}: {
  area: FragmentType<typeof SpotsListFragment>;
  /** 絞り込み対象カテゴリ。 null の場合は全件を表示。 */
  activeCategory: AreaGuideSpotCategory | null;
}) {
  const area = useFragment(SpotsListFragment, areaData);
  const visibleSpots = area.content.guideSpots.filter(
    (spot) =>
      activeCategory === null || spot.categories.includes(activeCategory),
  );
  return (
    // セクション上下余白は 16px (Figma 1024-22102: Contents 上 16px + 下も divider 手前 16px / Kkc0)。
    <div className="py-[16px]">
      {visibleSpots.length === 0 ? (
        <SpotsEmptyState hasActiveFilter={activeCategory !== null} />
      ) : (
        // grid + auto-fill: 1 行の要素数が最大に満たなくても各要素幅を揃える (Figma _WcyIyCT)。
        // flex-wrap だと最終行が flex-1 で間延びするため grid に変更。
        <ul className="grid grid-cols-[repeat(auto-fill,minmax(240px,1fr))] items-start">
          {visibleSpots.map((spot) => (
            <li key={spot.id} className="flex">
              <SpotCard spot={spot} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
